export const languageData = {
    northAmerica: [
        {
            region: 'United States',
            languages: [
                {
                    language: 'English',
                    link: 'https://www.tesla.com/'
                }
            ]
        },
        {
            region: 'Canada',
            languages: [
                {
                    language: 'English',
                    link: 'https://www.tesla.com/en_ca'
                },
                {
                    language: 'Français',
                    link: 'https://www.tesla.com/fr_ca'
                }
            ]
        },
        {
            region: 'Mexico',
            languages: [
                {
                    language: 'Español',
                    link: 'https://www.tesla.com/es_mx'
                }
            ]
        },
        {
            region: 'Puerto Rico',
            languages: [
                {
                    language: 'English',
                    link: 'https://www.tesla.com/es_pr'
                },
                {
                    language: 'Español',
                    link: 'https://www.tesla.com/es_pr'
                }
            ]
        }
    ],
    southAmerica: [
        {
            region: 'Chile',
            languages: [
                {
                    language: 'Español',
                    link: 'https://www.tesla.com/es_cl'
                }
            ]
        }
    ],
    middleEast: [
        {
            region: 'ישראל',
            languages: [
                {
                    language: 'עִברִית',
                    link: 'https://www.tesla.com/he_il'
                }
            ]
        },
        {
            region: 'UAE',
            languages: [
                {
                    language: 'English',
                    link: 'https://www.tesla.com/en_ae'
                },
                {
                    language: 'اَلْعَرَبِيَّةُ',
                    link: 'https://www.tesla.com/ar_ae'
                }
            ]
        },
        {
            region: 'Jordan',
            languages: [
                {
                    language: 'English',
                    link: 'https://www.tesla.com/en_jo'
                }
            ]
        },
        {
            region: 'Qatar',
            languages: [
                {
                    language: 'English',
                    link: 'https://www.tesla.com/en_qa'
                },
                {
                    language: 'اَلْعَرَبِيَّةُ',
                    link: 'https://www.tesla.com/ar_qa'
                }
            ]
        }
    ],
    asiaPacific: [
        {
            region: '中国大陆',
            languages: [
                {
                    language: '简体中文',
                    link: 'https://www.tesla.cn/'
                }
            ]
        },
        {
            region: 'Hong Kong',
            languages: [
                {
                    language: '繁體中文',
                    link: 'https://www.tesla.com/zh_hk'
                },
                {
                    language: 'English',
                    link: 'https://www.tesla.com/en_hk'
                }
            ]
        },
        {
            region: 'Macau',
            languages: [
                {
                    language: '繁體中文',
                    link: 'https://www.tesla.com/zh_mo'
                },
                {
                    language: 'English',
                    link: 'https://www.tesla.com/en_mo'
                }
            ]
        },
        {
            region: '台灣',
            languages: [
                {
                    language: '繁體中文',
                    link: 'https://www.tesla.com/zh_tw'
                }
            ]
        },
        {
            region: '日本',
            languages: [
                {
                    language: '日本語',
                    link: 'https://www.tesla.com/ja_jp'
                }
            ]
        },
        {
            region: 'Malaysia',
            languages: [
                {
                    language: 'English',
                    link: 'https://www.tesla.com/en_my'
                }
            ]
        },
        {
            region: 'Singapore',
            languages: [
                {
                    language: 'English',
                    link: 'https://www.tesla.com/en_sg'
                }
            ]
        },
        {
            region: 'Thailand',
            languages: [
                {
                    language: 'ภาษาไทย',
                    link: 'https://www.tesla.com/th_th'
                },
                {
                    language: 'English',
                    link: 'https://www.tesla.com/en_th'
                }
            ]
        },
        {
            region: '대한민국',
            languages: [
                {
                    language: '한국어',
                    link: 'https://www.tesla.com/ko_kr'
                }
            ]
        },
        {
            region: 'Australia',
            languages: [
                {
                    language: 'English',
                    link: 'https://www.tesla.com/en_au'
                }
            ]
        },
        {
            region: 'New Zealand',
            languages: [
                {
                    language: 'English',
                    link: 'https://www.tesla.com/en_nz'
                }
            ]
        }
    ],
    europe: [
        {
            region: 'Belgium',
            languages: [
                {
                    language: 'Nederlands',
                    link: 'https://www.tesla.com/nl_be'
                },
                {
                    language: 'Français',
                    link: 'https://www.tesla.com/fr_be'
                }
            ]
        },
        {
            region: 'Česko',
            languages: [
                {
                    language: 'Čeština',
                    link: 'https://www.tesla.com/cs_cz'
                }
            ]
        },
        {
            region: 'Danmark',
            languages: [
                {
                    language: 'Dansk',
                    link: 'https://www.tesla.com/da_dk'
                }
            ]
        },
        {
            region: 'Deutschland',
            languages: [
                {
                    language: 'Deutsch',
                    link: 'https://www.tesla.com/de_de'
                }
            ]
        },
        {
            region: 'Ελλάδα',
            languages: [
                {
                    language: 'Ελληνικά',
                    link: 'https://www.tesla.com/el_gr'
                }
            ]
        },
        {
            region: 'España',
            languages: [
                {
                    language: 'Español',
                    link: 'https://www.tesla.com/es_es'
                }
            ]
        },
        {
            region: 'France',
            languages: [
                {
                    language: 'Français',
                    link: 'https://www.tesla.com/fr_fr'
                }
            ]
        },
        {
            region: 'Hrvatska',
            languages: [
                {
                    language: 'Hrvatski',
                    link: 'https://www.tesla.com/hr_hr'
                }
            ]
        },
        {
            region: 'Magyarország',
            languages: [
                {
                    language: 'Magyar',
                    link: 'https://www.tesla.com/hu_hu'
                }
            ]
        },
        {
            region: 'Ireland',
            languages: [
                {
                    language: 'English',
                    link: 'https://www.tesla.com/en_ie'
                }
            ]
        },
        {
            region: 'Ísland',
            languages: [
                {
                    language: 'Íslenska',
                    link: 'https://www.tesla.com/is_is'
                }
            ]
        },
        {
            region: 'Italia',
            languages: [
                {
                    language: 'Italiano',
                    link: 'https://www.tesla.com/it_it'
                }
            ]
        },
        {
            region: 'Luxembourg',
            languages: [
                {
                    language: 'Français',
                    link: 'https://www.tesla.com/fr_lu'
                },
                {
                    language: 'Deutsch',
                    link: 'https://www.tesla.com/de_lu'
                }
            ]
        },
        {
            region: 'Nederland',
            languages: [
                {
                    language: 'Nederlands',
                    link: 'https://www.tesla.com/nl_nl'
                }
            ]
        },
        {
            region: 'Norge',
            languages: [
                {
                    language: 'Norsk',
                    link: 'https://www.tesla.com/no_no'
                }
            ]
        },
        {
            region: 'Österreich',
            languages: [
                {
                    language: 'Deutsch',
                    link: 'https://www.tesla.com/de_at'
                }
            ]
        },
        {
            region: 'Polska',
            languages: [
                {
                    language: 'Polski',
                    link: 'https://www.tesla.com/pl_pl'
                }
            ]
        },
        {
            region: 'Portugal',
            languages: [
                {
                    language: 'Português',
                    link: 'https://www.tesla.com/pt_pt'
                }
            ]
        },
        {
            region: 'România',
            languages: [
                {
                    language: 'Română',
                    link: 'https://www.tesla.com/ro_ro'
                }
            ]
        },
        {
            region: 'Slovenija',
            languages: [
                {
                    language: 'Slovenščina',
                    link: 'https://www.tesla.com/sl_si'
                }
            ]
        },
        {
            region: 'Switzerland',
            languages: [
                {
                    language: 'Français',
                    link: 'https://www.tesla.com/fr_ch'
                },
                {
                    language: 'Deutsch',
                    link: 'https://www.tesla.com/de_ch'
                },
                {
                    language: 'Italiano',
                    link: 'https://www.tesla.com/it_ch'
                }
            ]
        },
        {
            region: 'Sverige',
            languages: [
                {
                    language: 'Svenska',
                    link: 'https://www.tesla.com/sv_se'
                }
            ]
        },
        {
            region: 'Suomi',
            languages: [
                {
                    language: 'Suomi',
                    link: 'https://www.tesla.com/fi_fi'
                }
            ]
        },
        {
            region: 'Türkiye',
            languages: [
                {
                    language: 'Türkçe',
                    link: 'https://www.tesla.com/tr_tr'
                }
            ]
        },
        {
            region: 'United Kingdom',
            languages: [
                {
                    language: 'English',
                    link: 'https://www.tesla.com/en_gb'
                }
            ]
        },
        {
            region: 'Other Europe',
            languages: [
                {
                    language: 'English',
                    link: 'https://www.tesla.com/en_eu'
                }
            ]
        }
    ]
}